import React, { ReactNode, useState } from 'react';

interface TooltipProps {
    content: string;
    children: ReactNode;
    position?: 'top' | 'bottom' | 'left' | 'right';
    disabled?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children, position = 'top', disabled = false }) => {
    const [isVisible, setIsVisible] = useState(false);

    const positionClasses = {
        top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
    };

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && !disabled && (
                <div className={`absolute z-50 w-64 p-3 text-[11px] font-bold text-white bg-[#131B2C]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl animate-in fade-in zoom-in-95 duration-200 ${positionClasses[position]}`}>
                    {content}
                    <div className={`absolute w-0 h-0 border-4 border-solid border-transparent 
            ${position === 'top' ? 'border-t-[#131B2C] top-full left-1/2 -translate-x-1/2' : ''}
            ${position === 'bottom' ? 'border-b-[#131B2C] bottom-full left-1/2 -translate-x-1/2' : ''}
            ${position === 'left' ? 'border-l-[#131B2C] left-full top-1/2 -translate-y-1/2' : ''}
            ${position === 'right' ? 'border-r-[#131B2C] right-full top-1/2 -translate-y-1/2' : ''}
          `} />
                </div>
            )}
        </div>
    );
};
